import SEO from "@/components/SEO";
import Navbar, { MobileBottomBar } from "@/components/Navbar";
import Hero from "@/components/Hero";
import VillaManifesto from "@/components/VillaManifesto";
import Rooms from "@/components/Rooms";
import Gallery from "@/components/Gallery";
import Experiences from "@/components/Experiences";
import Reviews from "@/components/Reviews";
import Faq from "@/components/Faq";
import Contact, { Footer } from "@/components/Contact";
import { Marquee } from "@/components/Reveal";
import { useContent } from "@/App";

const MARQUEE_ITEMS = [
  "Entire villa, exclusively yours",
  "Copper sunsets over the Arabian Sea",
  "Steps from the Karwar coast",
  "Book direct — no middlemen",
  "Slow mornings, salt air",
  "Karwar · Karnataka · India",
];

export default function Home() {
  const content = useContent();
  if (!content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-charcoal" data-testid="home-loading">
        <p className="font-serif text-xl italic text-copper-300">Mystique Copper Villa…</p>
      </div>
    );
  }
  const { hero, villa, rooms, gallery, experiences, reviews, faq, settings, seo } = content;
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      name: "Mystique Copper Villa Homestay",
      description: seo?.home_description,
      address: settings?.address,
      telephone: settings?.phone || undefined,
      url: window.location.origin,
      image: seo?.og_image,
      ...(reviews?.rating && reviews?.count
        ? { aggregateRating: { "@type": "AggregateRating", ratingValue: reviews.rating, reviewCount: reviews.count } }
        : {}),
    },
    ...(faq?.length
      ? [{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
        }]
      : []),
  ];

  return (
    <main data-testid="home-page">
      <SEO title={seo?.home_title} description={seo?.home_description} image={seo?.og_image} path="/" jsonLd={jsonLd} />
      <Navbar />
      <Hero hero={hero} />
      <Marquee items={MARQUEE_ITEMS} />
      <VillaManifesto villa={villa} />
      <Rooms rooms={rooms} />
      <Gallery items={gallery} />
      <Experiences experiences={experiences} settings={settings} />
      <Reviews reviews={reviews} settings={settings} />
      <Faq faq={faq} />
      <Contact settings={settings} />
      <Footer settings={settings} />
      <MobileBottomBar />
    </main>
  );
}
